import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@all-manager/design-system-v2';
import { YearTotal } from '../../utils/expenseStats';
import { formatAmount, formatVariation } from '../../utils/formatAmount';

type Props = {
  'aria-label': string;
  totals: YearTotal[];
};

export default function CategoryYearTotals(props: Props) {
  return (
    <Table size="small" aria-label={props['aria-label']}>
      <TableHead>
        <TableRow>
          <TableCell>Année</TableCell>
          <TableCell align="right">Montant</TableCell>
          <TableCell align="right">Sur un an</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {props.totals.map((item) => (
          <TableRow key={item.year}>
            <TableCell scope="row">{item.year}</TableCell>
            <TableCell align="right">
              <Typography variant="body1Emphasis">{formatAmount(item.total)}</Typography>
            </TableCell>
            <TableCell align="right">
              {item.variation === null ? '—' : formatVariation(item.variation)}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
